<template>
	<div>
		<Titlebar :title="$route.name" />
		<Card>
			<StrapiList source="/campaigns" :query="{ archived: true }">
				<template v-slot="list">
					<CampaignsTable v-bind="list" />
				</template>
			</StrapiList>
		</Card>
	</div>
</template>

<script>
import Titlebar from '@/components/admin/Titlebar'
import Card from '@/components/shared/Card'
import StrapiList from '@/components/admin/StrapiList'
import CampaignsTable from '@/components/admin/CampaignsTable'

export default {
	name: 'ArchivedCampaigns',
	components: {
		Titlebar,
		Card,
		StrapiList,
		CampaignsTable
	}
}
</script>
